import { isBuilt } from '../../utilities/isBuilt'
import { getPrivateEnv } from '../getEnvs'

export const isLocalDev =
  (typeof window !== 'undefined' ? location.hostname.includes('localhost') : getPrivateEnv().ENVIRONMENT === 'local') ||
  !isBuilt
